import './Display.css';

function Display({msg}) {
    return (
        <div id='display'>
            <p>{msg}</p>
        </div>
    )
}

export default Display;